import axios from 'axios'

export function getDataList ({commit},payload) {
    
    axios.get (payload.url,  { params: payload.arg})
    .then(res => {
        
        if(res.data){                    
            if(!res.data.data || res.data.data.length == 0){
                this._vm.$toastr('error',"Nenhum registro encontrado");
                commit('pagination',{});
                commit('dataList',[]);
            }else{
            
                let pagination = {
                    current_page: res.data.meta.current_page,
                    last_page: res.data.meta.last_page,
                    next_page_url: res.data.links.next,
                    prev_page_url: res.data.links.prev
                };
                
                commit('pagination',pagination);
                commit('dataList',res.data.data);
            }
        }

    }, () => {        
        
        commit('pagination',{});
        commit('dataList',[]);
        this._vm.$toastr('error',"Ocorreu erro na operação, por favor tente novamente.");
    });     
}

export function getData({commit},payload) {
    commit('disableForm', true);


    const reqCombo = axios.get('/combo/'+payload)
    const reqBancoLookup = axios.get('combo/recuperacombotag/banco?addlinha=S'); 
    commit('selectLookup',[]);

    axios.all([reqCombo, reqBancoLookup]).then(axios.spread((...responses) => {
        const res = responses[0]
        const resBD = responses[1]
    
        // console.log('DATA',res);
        // console.log('BD',resBD);
        if(res.data){
            const lk ={bancos: resBD.data.combo}

            commit('data', res.data.data);
            commit('selectLookup', lk);            
            commit('disableForm', false);            
        }else{                        
            this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
        }
    })).catch(() => {
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })
}



export function saveData({getters,commit},payload) {
    
    let data = getters.data;
    let url = payload.url;//'/combo';
    let method = 'post';
    if (data.id && data.id!='') {
        url = payload.url+ "/" + data.id
        method = 'put';
    }
    
    axios({ method, url, data })    
    .then(res => {        
    
        if(res.data && res.data.sucesso){
             commit('data', res.data.data);
             this._vm.$toastr('success', "Registro gravado com sucesso.")
        }else{
            if(res.data && res.data.error && res.data.error.tag){
                this._vm.$toastr('error',"A tag já está sendo utilizada, por favor informe outra tag.")
            }else{	
                this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
            }
        }
    }, () =>{
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })
}



export function getSelectLookup({commit}) {
    commit('disableForm', true);

    axios.get('combo/recuperacombotag/banco?addlinha=S')  
    .then(res => {    
      
        if(res.data){
            const lk ={bancos: res.data.combo}           
            commit('selectLookup', lk);     
            commit('disableForm', false);            
        }else{
            this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
        }
    }, () =>{
        this._vm.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
    })    
}